<app-page-header [heading]="'Sales Return List'" [icon]="'fa-list-alt'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class="col-lg-12 row ">
    <div class="col-lg-8"></div>
    <div class="col-lg-4">
      <div class="row">
        <div class="input-group ">
          <input (keydown)="keyDownFunction($event)" [(ngModel)]="sale.search_sale" class="form-control"
                 id="typeahead-http" name="search_text"
                 placeholder="Customer Name/Invoice no/Invoice Date..." style="height:31px"
                 type="text">
          <div class="input-group-append">
            <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
              <i *ngIf="sale.search_sale != ''" class="fa fa-close"></i>
              <i *ngIf="sale.search_sale == ''" class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                                 style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>

  <div class="">
    <table class="  table tbl table-hover table-striped table-bordered">
      <thead>
      <tr class="text-center">
        <th width="1%">Sl#</th>
        <th>Customer Name</th>
        <th>Invoice Number</th>
        <th>Invoice Date</th>
        <th>Reference Number</th>
        <th>Return Date</th>
        <th>Total Amount</th>
        <th>View</th>
      </tr>
      <tr *ngIf="(sale_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let sale of sale_data;let i=index" style="font-size: 12px">
        <td>{{ i + 1 }}</td>
        <td>{{ sale.PATIENT_NAME }}</td>
        <td>{{ sale.INVOICE_NUMBER }}</td>
        <td>{{ utils.date(sale.SALE_DATE) }}</td>
        <td>{{ sale.REFERENCE_NUMBER }}</td>
        <td>{{ utils.date(sale.RETURN_DATE) }}</td>
        <td class="text-right">{{ sale.TOTAL_AMOUNT }}</td>
        <td>
          <button (click)="sale_items(sale);open(content);" alt="View" class="btn btn-sm btn-info"
                  style="font-size:10px"
                  title="View"><i class="fa fa-eye"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
    <app-pagination (pageChange)="getSaleReturnList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h3 class="modal-title" id="modal-basic-title">
        Particular List
      </h3>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="panel panel-default">
          <div class="panel-heading"></div>
        </div>
        <div *ngIf="saled" class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-4">
                <label>Customer Name</label>
              </div>
              <div class="col-lg-8">
                :&nbsp;<span class="tle">{{ saled.CUSTOMER_NAME }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-3">
                <label>Return Date</label>
              </div>
              <div class="col-lg-8">
                :&nbsp; <span class="tle">{{ utils.date(saled.RETURN_DATE) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-body">
          <table class="table tbl table-bordered" style="background-color: #f3f8fd">
            <thead>
            <tr class="text-center">
              <th>Sl</th>
              <th width="25%">Item</th>
              <th>Selling Qty</th>
              <th>Return Qty</th>
              <th>Rate</th>
              <th>Price</th>
              <th>Total</th>
              <th>Return Price</th>
              <th>Return Reason</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of item_list;let i=index">
              <td class="text-center">{{ 1 + i }}</td>
              <td> {{ item.TRADE_NAME }}</td>
              <td class="text-center">{{ item.QUANTITY }}</td>
              <td class="text-center">{{ item.RETURN_QUANTITY }}</td>
              <td class="text-right">{{ item.UNIT_PRICE }}</td>
              <td class="text-right">{{ item.PRICE }}</td>
              <td class="text-right">{{ item.TOTAL }}</td>
              <td class="text-right">{{ item.RETURN_TOTAL }}</td>
              <td>{{ item.RETURN_REASON }}</td>

            </tr>
            <tr>
              <th class="text-right" colspan="7" style="font-size:15px">Total</th>
              <th class="text-right">{{ total | number : '1.2-2' }}</th>
              <th class="text-right">{{ price_total | number : '1.2-2' }}</th>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-template>
